<template>
  <div id="EditPaShadowing" class="wrap">
    <v-app-bar extended extension-height="10" class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
      <v-layout class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Edit PA {{paShadow.pa_name}}</span> 
      </v-layout>
    </v-app-bar>

    <div class="maxContainer">
        <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
      <v-card class="px-1 mb-5 pt-5 offset-md-3 col-md-6 offset-sm-2 col-sm-8" flat  >
      
        <v-card-text class="mt-0 pt-0 px-0"> 
          <v-container grid-list-md>

            <!-- <div @click="back" class="headerFake__back">
              <a class="headerFake__backLink">
                <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
                <span class="headerFake__backText">Back</span>
              </a>
            </div> -->
            <v-form >
              <v-layout class="justify-center hidden-sm-and-down mb-3">
                <span class=" headline light-blue--text text--darken-3 text-center">Edit PA {{paShadow.pa_name}}</span> 
              </v-layout>
              <!-- PA Name -->
              <v-flex xs12>
                <v-text-field
                  v-model="paShadow.pa_name"               
                  label="Name"
                  outlined
                >
                </v-text-field>
              </v-flex>

              <!-- PA Email-->
              <v-flex xs12>
                <v-text-field
                  v-model="paShadow.pa_email"
                  label="Email" 
                  outlined
                ></v-text-field>
              </v-flex>

              <!-- PA Phone-->
                <v-flex xs12>
                  <v-text-field
                    v-model="paShadow.pa_phone"
                    label="Phone Number" 
                    outlined
                  ></v-text-field>
              </v-flex>

              <!-- PA Specialty -->
              <v-flex xs12>
                <v-text-field
                  v-model="paShadow.pa_speciality"               
                  label="Speciality"
                  outlined
                >
                </v-text-field>
              </v-flex>

              

              

              <!-- PA shadowing faciity-->
              <v-flex xs12>
                <v-text-field
                  v-model="paShadow.pa_shadowing_facility"
                  label="Facility Name" 
                  outlined
                ></v-text-field>
              </v-flex>
            </v-form>

            <v-layout row >
              <!-- Save Button -->
              <v-btn
                color="green"
                @click="editPaShadow"
                block
                depressed
                large
                >
            
                <span class="white--text"> Save</span>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>   
      </v-card>
    </div>
    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>

</template>

<script>
  export default {
    props: ['id'],
     data() {
      return {
        modal: false,
        alert: false,
        EditPaShadowDialog: false,
      }
    },
    methods: {
       back() {
        this.$router.go(-1);
      },
      showEditPaShadowDialog(user) {
        if(user !== null && user !== undefined ){
          this.EditPaShadowDialog = true
        }
        else {
          this.alert = true
          console.log('not logged in')
        }
      },
      editPaShadow () {
        const paInfo = {
          pa_name: this.paShadow.pa_name,
          pa_speciality: this.paShadow.pa_speciality,
          pa_email: this.paShadow.pa_email,
          pa_phone: this.paShadow.pa_phone,
          pa_shadowing_facility: this.paShadow.pa_shadowing_facility,
          paShadowId : this.paShadow.id,
        }
        this.EditPaShadowDialog = false
        this.$store.dispatch('setEditPaShadow', paInfo)
        this.$router.go(-1);

      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
       paShadow() {
      return this.$store.getters.paShadowInfo(this.id);
    },
    },
  }
</script>

<style scoped>
  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;
    
  }

.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap{
  margin-top: 8vh !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/PaShadowingHours/EditPaShadowing.vue